import { RolesUserService } from '@mangosoft/mango-layout';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { Modules } from '@mangosoft/mango-layout';
import { ConfigService, DataLoginService, AuthService } from '@mangosoft/mango-login';
import { Store } from '@ngrx/store';
import { loadConfig } from './infrastructure/store/actions/config.actions';
import { Title } from '@angular/platform-browser';

declare var require: any;
const version = require('../../../../package.json').version;
const url = environment.accessControlAPI;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  currentRoute: string = '';
  // Rutas que se muestran sin el sidebar/toolbar de mango-layout
  readonly publicRoutes = ['fill', 'landing'];
  version: string = '';
  loading = false;
  url = '';
  mode = 'desktop-close';
  listSidebar: Modules[] = [
    {
      id: 1,
      icon: 'dashboard',
      title: 'Dashboard',
      route: '/dashboard',
      status: true,
    },
  ];

  constructor(
    private serviceDataLogin: DataLoginService,
    private configService: ConfigService,
    private roleUserService: RolesUserService,
    private authService: AuthService,
    private store: Store,
    private titleService: Title
  ) {
    this.currentRoute = window.location.pathname.split('/')[1];
    this.configDataCore();
  }

  get isPublicRoute(): boolean {
    return this.publicRoutes.includes(this.currentRoute);
  }

  ngOnInit(): void {
    //this.roleUserService.getPermissions.subscribe((resp) => console.log(resp));


    this.roleUserService.getPermissions.subscribe((resp: any) => {
      let roles: any[] = [];
      this.listSidebar = [];
      if (resp?.permissions) {
        resp.permissions.forEach((permissions: any) => {
          //console.log('permissions-->', permissions);
          if (permissions.host === location.hostname) {
            roles = permissions.roles;
          }
        });
        let allResources: any[] = [];
        roles.forEach((role) => {
          allResources.push(...role.resources);
        });
        //console.log('allResources-->', allResources);
        const isAuthenticated = allResources.some(
          (resource) =>
            resource.path.toLowerCase().includes('signin') &&
            resource.action.toLowerCase().includes('post')
        );
        if (!isAuthenticated) {
          this.authService.logout();
        }

      }
    });

  }

  configDataCore() {
    this.configService.config(url, {pk: environment.modulePk, sk: environment.moduleSk}, environment.secretbKey).then((response) => {
      this.loading
      this.store.dispatch(loadConfig({ data: response }));
      this.loadWindowData(response);
    });
    this.version = version;
    this.url = url;
    this.serviceDataLogin.saveData({
      version,
      url,
      route: 'dashboard',
    });
  }

  loadWindowData(response: any) {
    if(response?.FORM_WINDOW_DATA) {
      if(response.FORM_WINDOW_DATA.TITLE) {
        this.setTitle(response.FORM_WINDOW_DATA.TITLE);
      }
      if(response.FORM_WINDOW_DATA.ICON) {
        this.setFavicon(response.FORM_WINDOW_DATA.ICON);
      }
    } 
  }

  setFavicon(faviconUrl: string) {
    const link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") ||
      document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = faviconUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

}
